export interface EditPlaygroupsState {
  returnRoute?: string;
}

export enum EditPlaygroupsSteps {
  confirm = 1,
  edit = 2,
}
